import {createFileRoute} from '@tanstack/react-router'

import {ThirdPartyRentalCompaniesPage} from '../../../../assets/rental-assets/third-party-rental-companies-page'

export const Route = createFileRoute('/_app/rental-assets/companies/')({
    component: ThirdPartyRentalCompaniesRoute,
})

function ThirdPartyRentalCompaniesRoute() {
    return <ThirdPartyRentalCompaniesPage />
}
